/**
 * @file 审核通过
 */

import { fetch, fetchData } from '@umu/umu-fetch';
import API from '../../path';

export interface IInput {
    id: string;
}

/**
 * 给class组件用
 */
export const getEnterpriseConfig = (param: IInput): Promise<IResponse<IEnterpriseConfig>> => {
    return fetch
        .get(API.GET_ENTERPRISE_CONFIG.url, param, { silent: true })
        .then((res: IResponse<IEnterpriseConfig>) => {
            return res;
        })
        .catch(() => {
            return { data: { status: 0 } };
        });
};

/**
 * 获取企业设置
 * @param UnknownObj
 * @returns UnknownObj
 */
export const enterpriseGetSetup = (field: string): Promise<IResponse<Record<string, unknown>>> => {
    return fetchData(API.ENTERPRISE_GET_SETUP, { field }).then((res: IResponse<Record<string, unknown>>) => {
        return res;
    });
};
